import { render } from "./ModalVault.vue?vue&type=template&id=328ad064&scoped=true"
import script from "./ModalVault.vue?vue&type=script&lang=js"
export * from "./ModalVault.vue?vue&type=script&lang=js"

import "./ModalVault.vue?vue&type=style&index=0&id=328ad064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328ad064"]])

export default __exports__